<div class="delete-confirmation">
  <div>
      <div class="confirmation-line1"><h4>Are you sure you want to delete selected inspections?</h4></div>

  </div>

  <div class="button-container" style="margin-bottom: 10%;">
      <a class="button button-no" (click)="onCloseClick()">
          <span class="button__text">No</span>
      </a>
      <a class="button button--primary button-yes" (click)="onConfirmDeleteClick()">
          <span class="button__text">Yes</span>
      </a>
  </div>
</div>